import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {AssetProjectPref} from '../constants';

export const assetProjectEnabled = () =>
    getPreference(AssetProjectPref.ENABLED, true);
